var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('q-score-card',{key:"QScoreCardRecruitingLeads",attrs:{"title":"Recruiting Leads","api-endpoint":"leads/recruiting","drill-down-route":"","card-style":"leads","agent-code":_vm.agentCode,"filters":_vm.filters},on:{"most_current":_vm.updateMostCurrent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }